import { API_BASE_URL } from './api';

const API_URL = `${API_BASE_URL}/vouchers`;
class ApiError extends Error {
  voucher_status?: number;

  constructor(message: string, voucher_status?: number) {
    super(message);
    this.name = 'ApiError';
    this.voucher_status = voucher_status;
  }
}

// Helper to handle fetch responses
async function handleResponse(response: Response) {
  const contentType = response.headers.get('content-type');
  const data = contentType && contentType.includes('application/json')
    ? await response.json()
    : await response.text();

  if (!response.ok) {
    throw new ApiError(
      (data && (data.message || data.error)) || 'Request failed',
      response.status
    );
  }

  return data;
}

// -------------------- GET all Vouchers --------------------
export const getVouchers = async () => {
  try {
    console.log(`🔍 Fetching voucher from: ${API_BASE_URL}/vouchers`);
    const response = await fetch(`${API_BASE_URL}/vouchers`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    const data = await handleResponse(response);
    console.log('✅ vouchers API response:', data);
    return data;
  } catch (error: any) {
    console.error('❌ vouchers API error:', error);
    if (error instanceof ApiError) throw error;
    throw new Error('Network error while fetching vouchers');
  }
};

// -------------------- GET single Voucher --------------------
export const getVoucherById = async (id: string) => {
  try {
    const response = await fetch(`${API_BASE_URL}/vouchers/${id}`);
    return await handleResponse(response);
  } catch (error: any) {
    if (error instanceof ApiError) throw error;
    throw new Error(`Network error while fetching voucher ${id}`);
  }
};

// -------------------- CREATE FAQ --------------------
export const createVoucher = async (voucherData: {
  service_id: number | null;
  voucher_code: string;
  voucher_description: string;
  voucher_type: 'Percentage' | 'Fixed Price';
  voucher_discount: number;
  voucher_status: 'Active' | 'Inactive';
}) => {
  try {
    const response = await fetch(`${API_BASE_URL}/vouchers`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(voucherData),
    });
    return await handleResponse(response);
  } catch (error: any) {
    if (error instanceof ApiError) throw error;
    throw new Error('Network error while creating voucher');
  }
};

// -------------------- UPDATE FAQ --------------------
export const updateVoucher = async (
  voucher_id: number,
  voucherData: {
    service_id: number | null;
    voucher_code: string;
    voucher_description: string;
    voucher_type: 'Percentage' | 'Fixed Price';
    voucher_discount: number;
    voucher_status: 'Active' | 'Inactive';
  }
) => {
  try {
    const response = await fetch(`${API_BASE_URL}/vouchers/${voucher_id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(voucherData),
    });
    return await handleResponse(response);
  } catch (error: any) {
    if (error instanceof ApiError) throw error;
    throw new Error(`Network error while updating voucher ${voucher_id}`);
  }
};

// -------------------- DELETE FAQ --------------------
export const deleteVoucher = async (voucher_id: number,
   voucherData: {
    voucher_status:'Delete';
  }
) => {
  try {
    const response = await fetch(`${API_BASE_URL}/vouchers/${voucher_id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(voucherData),
    });
    return await handleResponse(response);
  } catch (error: any) {
    if (error instanceof ApiError) throw error;
    throw new Error(`Network error while deleting voucher ${voucher_id}`);
  }
};

// -------------------- GET all Vouchers --------------------
export const getServices = async () => {
  try {
    console.log(`🔍 Fetching voucher from: ${API_BASE_URL}/services`);
    const response = await fetch(`${API_BASE_URL}/services`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    const data = await handleResponse(response);
    console.log('✅ services API response:', data);
    return data;
  } catch (error: any) {
    console.error('❌ services API error:', error);
    if (error instanceof ApiError) throw error;
    throw new Error('Network error while fetching services');
  }
};

// Helper to handle fetch + error
// const request = async (url: string, options?: RequestInit) => {
//   const res = await fetch(url, {
//     headers: { 'Content-Type': 'application/json' },
//     ...options,
//   });

//   if (!res.ok) {
//     const errData = await res.json().catch(() => null);
//     throw new Error(errData?.error || 'Request failed');
//   }

//   return res.json().catch(() => null);
// };

// Get all vouchers
// export const getVouchers = async (): Promise<Voucher[]> => {
//   return request(`${API_BASE_URL}/vouchers`);
// };


// Get a single voucher by ID
// export const getVoucherById = async (id: number): Promise<Voucher> => {
//   return request(`${API_URL}/${id}`);
// };

// Create a new voucher
// export const createVoucher = async (
//   voucherData: Omit<Voucher, 'voucher_id' | 'created_at' | 'updated_at'>
// ): Promise<Voucher> => {
//   return request(API_URL, {
//     method: 'POST',
//     body: JSON.stringify(voucherData),
//   });
// };

// Update an existing voucher
// export const updateVoucher = async (
//   id: number,
//   voucherData: Partial<Voucher>
// ): Promise<Voucher> => {
//   return request(`${API_URL}/${id}`, {
//     method: 'PUT',
//     body: JSON.stringify(voucherData),
//   });
// };

// Delete a voucher (soft delete)
// export const deleteVoucher = async (id: number): Promise<void> => {
//   await request(`${API_URL}/${id}`, {
//     method: 'DELETE',
//   });
// };
